<template>
  <div class="app-container">
    <el-form ref="form" :model="form" label-width="120px" class="el-form-title">
      <el-form-item label="任务资源库名称">
        <el-input v-model="form.name" placeholder="请输入需要查询的任务资源库名称" />
      </el-form-item>
      <el-form-item label="任务资源库分类">
        <el-select v-model="storyType" filterable placeholder="请选择需要查询的任务资源库类型" value-key="code">
          <el-option v-for="(type) in typeList" :key="type.code" :label="type.value" :value="type" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <div class="align-right">
          <el-button @click="fetchData">查询</el-button>
          <el-button @click="addStory">新增</el-button>
        </div>
      </el-form-item>
    </el-form>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      height="48"
      border=""
      :header-cell-style="{background:'rgb(244 244 244)'}"
    >
      <el-table-column align="center" label="任务资源库名称" min-width="180" fixed="left">
        <template slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="状态" min-width="100">
        <template slot-scope="scope">
          {{ scope.row.status_desc }}
        </template>
      </el-table-column>

      <el-table-column align="center" prop="created_at" label="创建人" min-width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.createdBy }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="created_at" label="更新人" min-width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.updatedBy }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="created_at" label="任务资源库分类" min-width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.storyType }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="created_at" label="创建时间" min-width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="created_at" label="更新时间" min-width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.updateTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="描述" min-width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.description || '暂无' }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="220" fixed="right">
        <template slot-scope="scope">
          <el-button v-if="scope.row.status !== 'pending'" @click="delItem(scope.row.id)">删除</el-button>
          <el-button v-if="scope.row.status === 'success'" @click="editItem(scope.row)">编辑</el-button>
          <el-button v-if="scope.row.status === 'fail'" @click="reason(scope.row)">查看原因</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>

import { getStoryType } from '@/api/exercise'
import { taskBaseList, delTask } from '@/api/knowledgeUpload'
import dayjs from 'dayjs'

export default {
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: 'success',
        draft: 'gray',
        deleted: 'danger'
      }
      return statusMap[status]
    }
  },
  data() {
    return {
      storyType: { code: '', value: '' },
      typeList: [],
      list: null,
      listLoading: false,
      form: {
        name: ''
      }
    }
  },
  created() {
    this.fetchData()
    this.getType()
  },
  methods: {
    reason(val) {
      this.$alert(val.errorMsg, '失败的原因', {
        confirmButtonText: '确定',
        showClose: false
      })
    },
    getType() {
      getStoryType().then(res => {
        console.log('getStoryType', res)
        this.typeList = res.data
      })
    },
    fetchData() {
      this.listLoading = true
      taskBaseList({ name: this.form.name, storyType: this.storyType.code }).then(response => {
        console.log('res-----', response.data)
        response.data.forEach(res => {
          res.createTime = dayjs(res.createTime).format('YYYY-MM-DD HH:mm:ss')
          res.updateTime = dayjs(res.updateTime).format('YYYY-MM-DD HH:mm:ss')
          res.status_desc = res.status === 'pending' ? '生成中' : res.status === 'success' ? '成功' : res.status === 'fail' ? '失败' : ''
        })
        this.list = response.data
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
      })
    },
    addStory() {
      this.$router.push({ name: 'taskBaseDetail' })
    },
    editItem(detail) {
      console.log('scope', detail)
      this.$router.push({ name: 'taskBaseDetail', params: { id: detail.id }})
    },
    delItem(id) {
      this.$confirm('此操作将删除该步骤, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delTask({ id }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功',
            duration: 2 * 1000
          })
          this.fetchData()
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep{
  .el-table{
    overflow: auto;
  }
  .el-form-item__content{
    display: flex;
    position: relative;
  }
  .el-button {
    margin-left: 10px;
  }
  .el-button:last-child{
    color: #FFF;
    background-color: #409EFF;
  }
  .el-input__inner {
    width: 400px;
  }
}
// .align-right {
//   position: absolute;
//   right: 0;
// }
.el-form-title {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
</style>

